import { EvidenceForm } from "./form";

export function EvidenceCreate() {
  return <EvidenceForm action="create" />;
}

export default EvidenceCreate;
